const deThiTracNghiem = [
  // ĐỀ SỐ 1
  {
    id: 'de_so_1',
    tenDe: 'Kiểm tra kiến thức Văn hóa các dân tộc Việt Nam',
    cauHoi: [
      {
        id: '1_1',
        noiDung: 'Theo bài viết, dân tộc Dao còn được gọi bằng tên nào khác?',
        dapAn: {
          A: 'Người Kinh',
          B: 'Người Dìu Miền hoặc Yao',
          C: 'Người Mông',
          D: 'Người Tày'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '1_2',
        noiDung: 'Nguyên liệu chính để người H’Mông dệt vải truyền thống là gì?',
        dapAn: {
          A: 'Sợi tơ tằm',
          B: 'Sợi bông',
          C: 'Sợi lanh',
          D: 'Sợi đay'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '1_3',
        noiDung: 'Dân tộc Khmer ở Việt Nam sinh sống chủ yếu ở khu vực nào?',
        dapAn: {
          A: 'Miền núi phía Bắc',
          B: 'Đồng bằng sông Hồng',
          C: 'Duyên hải Nam Trung Bộ',
          D: 'Đồng bằng sông Cửu Long'
        },
        cauTraLoiDung: 'D'
      },
      {
        id: '1_4',
        noiDung: 'Màu sắc chủ đạo trên vải thổ cẩm của người Mạ thường là gì?',
        dapAn: {
          A: 'Xanh dương và trắng',
          B: 'Tím và hồng',
          C: 'Đỏ, đen, vàng, và trắng',
          D: 'Chỉ có màu đen'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '1_5',
        noiDung: 'Kỹ thuật nhuộm "kháng nhuộm" sử dụng sáp ong để tạo họa tiết có tên gọi phổ biến là gì?',
        dapAn: {
          A: 'Nhuộm chàm',
          B: 'Nhuộm sáp ong (Batik)',
          C: 'Nhuộm buộc (Tie-dye)',
          D: 'Nhuộm in hoa'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '1_6',
        noiDung: 'Theo truyền thuyết của người Dao, ai là người đã sáng tạo ra nghề nhuộm vải chàm?',
        dapAn: {
          A: 'Các vị thần linh trên núi',
          B: 'Các chiến binh sau trận chiến',
          C: 'Các bà, các mẹ trong cộng đồng',
          D: 'Các vị vua và hoàng hậu'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '1_7',
        noiDung: 'Đâu là món ăn truyền thống không thể thiếu và thường được nấu thành súp của người H’Mông?',
        dapAn: {
          A: 'Phở bò',
          B: 'Bún chả',
          C: 'Dưa muối',
          D: 'Cơm lam'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '1_8',
        noiDung: 'Lễ hội Chôl Chnăm Thmây là Tết cổ truyền của dân tộc nào?',
        dapAn: {
          A: 'Dân tộc Tày',
          B: 'Dân tộc Dao',
          C: 'Dân tộc Khmer',
          D: 'Dân tộc Mạ'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '1_9',
        noiDung: 'Dân tộc Lô Lô ở Việt Nam được chia thành những nhóm chính nào?',
        dapAn: {
          A: 'Lô Lô Đỏ và Lô Lô Xanh',
          B: 'Lô Lô Đen, Lô Lô Hoa và Lô Lô Trắng',
          C: 'Lô Lô Núi và Lô Lô Sông',
          D: 'Lô Lô Tiền và Lô Lô Chàm'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '1_10',
        noiDung: 'Dân tộc nào có dân số đông thứ hai tại Việt Nam, chỉ sau người Kinh?',
        dapAn: {
          A: 'Người Nùng',
          B: 'Người Mông',
          C: 'Người Tày',
          D: 'Người Dao'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '1_11',
        noiDung: 'Theo tín ngưỡng người Dao, màu chàm trên trang phục có ý nghĩa tâm linh gì?',
        dapAn: {
          A: 'Tượng trưng cho sự giàu có và quyền lực.',
          B: 'Giúp xua đuổi tà ma và mang lại may mắn.',
          C: 'Thể hiện sự tang tóc và đau buồn.',
          D: 'Chỉ là màu sắc trang trí cho đẹp mắt.'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '1_12',
        noiDung: 'Trang phục của phụ nữ nhóm Dao nào đặc trưng với việc đính các đồng xu bạc?',
        dapAn: {
          A: 'Dao Đỏ',
          B: 'Dao Quần Chẹt',
          C: 'Dao Thanh Y',
          D: 'Dao Tiền'
        },
        cauTraLoiDung: 'D'
      },
      {
        id: '1_13',
        noiDung: 'Làng nghề dệt thổ cẩm nổi tiếng nhất của người Chăm ở Ninh Thuận là làng nào?',
        dapAn: {
          A: 'Làng Vạn Phúc',
          B: 'Làng Mỹ Nghiệp và Chung Mỹ',
          C: 'Làng Luống Nọi',
          D: 'Làng Pác Rằng'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '1_14',
        noiDung: 'Người Nùng sống tập trung chủ yếu ở khu vực nào của Việt Nam?',
        dapAn: {
          A: 'Đồng bằng sông Cửu Long',
          B: 'Tây Nguyên',
          C: 'Duyên hải Nam Trung Bộ',
          D: 'Các tỉnh đông bắc Bắc Bộ'
        },
        cauTraLoiDung: 'D'
      },
      {
        id: '1_15',
        noiDung: 'Nghề dệt vải của người Mạ được truyền lại chủ yếu qua ai?',
        dapAn: {
          A: 'Cha truyền cho con trai.',
          B: 'Thầy giáo dạy cho học trò trong trường làng.',
          C: 'Mẹ truyền cho con gái.',
          D: 'Nghệ nhân trong làng dạy chung cho cả nam và nữ.'
        },
        cauTraLoiDung: 'C'
      }
    ]
  },
  // ĐỀ SỐ 2: HÌNH HỌC VÀ ĐỐI XỨNG TRONG HỌA TIẾT
  {
    id: 'de_so_2',
    tenDe: 'Khám phá Toán học trong Họa tiết truyền thống',
    cauHoi: [
      {
        id: '2_1',
        noiDung: 'Trong họa tiết vải, khi một hình được lặp đi lặp lại theo một hướng cố định mà không thay đổi hình dạng, đó là loại đối xứng nào?',
        dapAn: {
          A: 'Đối xứng gương',
          B: 'Đối xứng quay',
          C: 'Đối xứng tịnh tiến',
          D: 'Đối xứng tâm'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '2_2',
        noiDung: 'Một hình vuông có tất cả bao nhiêu trục đối xứng?',
        dapAn: {
          A: '1 trục',
          B: '2 trục',
          C: '4 trục',
          D: 'Vô số trục'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '2_3',
        noiDung: 'Một họa tiết hình ngôi sao 6 cánh đều nhau sẽ có đối xứng quay bậc mấy?',
        dapAn: {
          A: 'Bậc 3 (khi xoay 120 độ)',
          B: 'Bậc 4 (khi xoay 90 độ)',
          C: 'Bậc 6 (khi xoay 60 độ)',
          D: 'Bậc 8 (khi xoay 45 độ)'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '2_4',
        noiDung: 'Trong họa tiết thổ cẩm của người Mạ, hình dạng nào thường được dùng để mô tả các đỉnh núi?',
        dapAn: {
          A: 'Hình tròn',
          B: 'Hình vuông',
          C: 'Hình tam giác',
          D: 'Hình lục giác'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '2_5',
        noiDung: 'Trong toán học, đường thẳng chia một hình thành hai phần là ảnh phản chiếu của nhau được gọi là gì?',
        dapAn: {
          A: 'Trục tung',
          B: 'Trục hoành',
          C: 'Trục đối xứng',
          D: 'Đường phân giác'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '2_6',
        noiDung: 'Hình ảnh nào trong tự nhiên là ví dụ điển hình của đối xứng gương (đối xứng trục)?',
        dapAn: {
          A: 'Vỏ ốc sên',
          B: 'Thân cây',
          C: 'Cánh bướm',
          D: 'Mạng nhện'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '2_7',
        noiDung: 'Họa tiết hình quả trám trong thổ cẩm còn có tên gọi hình học là gì?',
        dapAn: {
          A: 'Hình bình hành',
          B: 'Hình thoi',
          C: 'Hình thang',
          D: 'Hình chữ nhật'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '2_8',
        noiDung: 'Hình dạng nào thường tượng trưng cho sự trọn vẹn, thống nhất và là tâm điểm của các hoa văn?',
        dapAn: {
          A: 'Hình tròn',
          B: 'Hình vuông',
          C: 'Hình tam giác',
          D: 'Hình ngôi sao'
        },
        cauTraLoiDung: 'A'
      },
      {
        id: '2_9',
        noiDung: 'Khi một họa tiết có thể xoay quanh tâm một góc 90 độ và giữ nguyên hình dạng, nó có đối xứng quay bậc mấy?',
        dapAn: {
          A: 'Bậc 2',
          B: 'Bậc 3',
          C: 'Bậc 4',
          D: 'Bậc 8'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '2_10',
        noiDung: 'Họa tiết hình con sên hoặc đường cong liên tục tạo thành các vòng tròn quanh một điểm trung tâm được gọi là gì?',
        dapAn: {
          A: 'Đường elip',
          B: 'Đường zigzag',
          C: 'Đường xoắn ốc',
          D: 'Đường parabol'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '2_11',
        noiDung: '"Đối xứng gương" còn có tên gọi khác trong toán học là gì?',
        dapAn: {
          A: 'Đối xứng tịnh tiến',
          B: 'Đối xứng quay',
          C: 'Đối xứng phản xạ (Đối xứng trục)',
          D: 'Đối xứng tâm'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '2_12',
        noiDung: 'Trong các họa tiết lặp lại, hình dạng nào có thể ghép lại với nhau để tạo thành mạng lưới hình tổ ong?',
        dapAn: {
          A: 'Hình tam giác',
          B: 'Hình vuông',
          C: 'Hình ngũ giác',
          D: 'Hình lục giác'
        },
        cauTraLoiDung: 'D'
      },
      {
        id: '2_13',
        noiDung: 'Việc sắp xếp các hàng gạch hoặc các hàng cột trong kiến trúc là ví dụ cho loại đối xứng nào?',
        dapAn: {
          A: 'Đối xứng gương',
          B: 'Đối xứng quay',
          C: 'Đối xứng tịnh tiến',
          D: 'Không có đối xứng'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '2_14',
        noiDung: 'Họa tiết hai con rồng chầu vào một viên ngọc thường được sắp xếp theo loại đối xứng nào?',
        dapAn: {
          A: 'Đối xứng qua trục',
          B: 'Đối xứng tịnh tiến',
          C: 'Đối xứng quay',
          D: 'Không đối xứng'
        },
        cauTraLoiDung: 'A'
      },
      {
        id: '2_15',
        noiDung: 'Tổng các góc trong của một đa giác có 6 cạnh (hình lục giác) là bao nhiêu độ?',
        dapAn: {
          A: '360°',
          B: '540°',
          C: '720°',
          D: '1080°'
        },
        cauTraLoiDung: 'C'
      }
    ]
  },
  {
    id: 'de_so_3',
    tenDe: 'Tìm hiểu Văn hóa các dân tộc (Phần 1)',
    cauHoi: [
      {
        id: '3_1',
        noiDung: 'Theo bài viết, kỹ thuật nhuộm chàm của người Dao được truyền từ đời này sang đời khác và gắn liền với điều gì?',
        dapAn: {
          A: 'Đời sống du mục và săn bắn hái lượm.',
          B: 'Đời sống sinh hoạt hàng ngày cũng như các nghi lễ quan trọng.',
          C: 'Chỉ dành cho tầng lớp quý tộc và vua chúa.',
          D: 'Chỉ được sử dụng trong các cuộc chiến tranh.'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '3_2',
        noiDung: 'Trang phục của người H’Mông thường đi kèm với các phụ kiện làm từ chất liệu gì để thể hiện sự quan trọng trong đời sống tinh thần?',
        dapAn: {
          A: 'Vàng',
          B: 'Đồng',
          C: 'Bạc',
          D: 'Gỗ'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '3_3',
        noiDung: 'Tôn giáo nào có ảnh hưởng sâu sắc đến văn hóa và kiến trúc chùa của người Khmer ở Việt Nam?',
        dapAn: {
          A: 'Phật giáo Đại Thừa',
          B: 'Phật giáo Nam Tông (Theravada)',
          C: 'Nho giáo',
          D: 'Hồi giáo'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '3_4',
        noiDung: 'Trong tín ngưỡng của người Mạ, các họa tiết hình con vật trên thổ cẩm biểu trưng cho điều gì?',
        dapAn: {
          A: 'Sự giàu có và quyền lực của người mặc.',
          B: 'Sự gắn kết giữa con người và thiên nhiên, và sự bảo trợ của thần linh động vật.',
          C: 'Các câu chuyện cổ tích và thần thoại.',
          D: 'Sự hung dữ và nguy hiểm của các loài thú trong rừng.'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '3_5',
        noiDung: 'Ai là người đóng vai trò trung tâm trong việc duy trì và phát triển nghề dệt thổ cẩm của người Chăm?',
        dapAn: {
          A: 'Nam giới, đặc biệt là các già làng.',
          B: 'Các nhà sư trong các ngôi chùa.',
          C: 'Phụ nữ, với kỹ năng được truyền từ mẹ sang con gái.',
          D: 'Trẻ em trong các lớp học cộng đồng.'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '3_6',
        noiDung: 'Lễ Cấp Sắc là nghi lễ trưởng thành quan trọng nhất của đối tượng nào trong cộng đồng người Dao?',
        dapAn: {
          A: 'Tất cả các cô gái đến tuổi lấy chồng.',
          B: 'Tất cả trẻ em khi lên 10 tuổi.',
          C: 'Những người già trong làng.',
          D: 'Những người đàn ông trong cộng đồng.'
        },
        cauTraLoiDung: 'D'
      },
      {
        id: '3_7',
        noiDung: 'Theo truyền thuyết, người Lô Lô có mối liên hệ mật thiết với tộc người nào ở Trung Quốc?',
        dapAn: {
          A: 'Tộc Hán',
          B: 'Tộc Mãn',
          C: 'Tộc Di',
          D: 'Tộc Hồi'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '3_8',
        noiDung: 'Vải thổ cẩm của người Nùng thường được làm từ những nguyên liệu nào?',
        dapAn: {
          A: 'Chỉ làm từ sợi len cừu.',
          B: 'Sợi bông, lanh, hoặc tơ tằm.',
          C: 'Chỉ làm từ sợi nilon công nghiệp.',
          D: 'Chỉ làm từ sợi đay.'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '3_9',
        noiDung: 'Dân tộc Tày có loại chữ viết cổ nào đã được ghi danh là di sản văn hóa phi vật thể của Việt Nam?',
        dapAn: {
          A: 'Chữ Quốc ngữ',
          B: 'Chữ Hán cổ',
          C: 'Chữ Nôm-Tày',
          D: 'Chữ Phạn'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '3_10',
        noiDung: 'Trong lễ tang của người Dao, vải chàm được dùng để làm gì?',
        dapAn: {
          A: 'Để trang trí nhà cửa cho bớt tang thương.',
          B: 'Làm quà tặng cho khách đến viếng.',
          C: 'Làm quần áo cho người đã khuất với mong muốn linh hồn được che chở.',
          D: 'Để đốt cùng các vật dụng khác theo nghi lễ.'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '3_11',
        noiDung: 'Theo các nhà khảo cổ, sợi lanh bắt đầu được con người sử dụng từ cách đây bao lâu?',
        dapAn: {
          A: 'Hơn 1,000 năm.',
          B: 'Hơn 5,000 năm.',
          C: 'Hơn 10,000 năm.',
          D: 'Hơn 30,000 năm.'
        },
        cauTraLoiDung: 'D'
      },
      {
        id: '3_12',
        noiDung: 'Trong các nghi lễ Phật giáo của người Khmer, vải đay thường được dùng để may trang phục cho ai?',
        dapAn: {
          A: 'Các phật tử đi lễ chùa.',
          B: 'Các nhà sư (áo cà sa).',
          C: 'Trẻ em trong các dịp lễ hội.',
          D: 'Vua chúa và quan lại.'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '3_13',
        noiDung: 'Trong tín ngưỡng của người Mạ, màu đỏ trên thổ cẩm tượng trưng cho điều gì?',
        dapAn: {
          A: 'Sự tinh khiết và linh thiêng.',
          B: 'Sự sống và sức mạnh.',
          C: 'Đất đai và sự bền vững.',
          D: 'Sự giàu có và phồn thịnh.'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '3_14',
        noiDung: 'Họa tiết nào sau đây là một trong những họa tiết nổi tiếng trên thổ cẩm của người Chăm?',
        dapAn: {
          A: '"Mắt hổ" (mata harimau)',
          B: '"Vuốt rồng"',
          C: '"Vảy cá chép"',
          D: '"Lông chim công"'
        },
        cauTraLoiDung: 'A'
      },
      {
        id: '3_15',
        noiDung: 'Trong nghi lễ tang lễ của người Lô Lô, nhạc cụ nào được sử dụng để giúp linh hồn người đã khuất trở về với tổ tiên?',
        dapAn: {
          A: 'Cồng chiêng',
          B: 'Sáo trúc',
          C: 'Đàn đá',
          D: 'Trống đồng'
        },
        cauTraLoiDung: 'D'
      }
    ]
  },
  // ĐỀ SỐ 4: HÌNH HỌC VÀ ĐỐI XỨNG (NÂNG CAO)
  {
    id: 'de_so_4',
    tenDe: 'Toán học và Họa tiết (Phần 1)',
    cauHoi: [
      {
        id: '4_1',
        noiDung: 'Hình dạng nào được định nghĩa là "một đa giác có 3 đỉnh và 3 cạnh"?',
        dapAn: {
          A: 'Hình vuông',
          B: 'Hình tròn',
          C: 'Hình tam giác',
          D: 'Hình thoi'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '4_2',
        noiDung: 'Một hình trái tim cân đối có mấy trục đối xứng?',
        dapAn: {
          A: '0',
          B: '1',
          C: '2',
          D: '4'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '4_3',
        noiDung: 'Trong đối xứng quay, góc quay nhỏ nhất mà họa tiết trở lại như ban đầu được gọi là gì?',
        dapAn: {
          A: 'Góc vuông',
          B: 'Góc đối xứng quay',
          C: 'Góc bẹt',
          D: 'Góc phản xạ'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '4_4',
        noiDung: '"Đối xứng tịnh tiến rời rạc" có nghĩa là gì?',
        dapAn: {
          A: 'Họa tiết có thể dịch chuyển một cách mượt mà và liên tục.',
          B: 'Họa tiết chỉ lặp lại tại các vị trí cố định, cách nhau một khoảng cách đều đặn.',
          C: 'Họa tiết lặp lại một cách ngẫu nhiên, không theo quy luật.',
          D: 'Họa tiết lặp lại khi được xoay quanh một điểm.'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '4_5',
        noiDung: 'Trong toán học, "Đối xứng qua trục" là phép biến hình biến mỗi điểm A thành điểm B sao cho trục là đường gì của đoạn thẳng AB?',
        dapAn: {
          A: 'Đường phân giác',
          B: 'Đường trung tuyến',
          C: 'Đường trung trực',
          D: 'Đường cao'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '4_6',
        noiDung: 'Họa tiết hình ngôi sao 4 cánh đều nhau có đối xứng quay bậc mấy?',
        dapAn: {
          A: 'Bậc 2',
          B: 'Bậc 4',
          C: 'Bậc 6',
          D: 'Bậc 8'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '4_7',
        noiDung: 'Họa tiết nào được tạo thành từ các góc nhỏ có góc thay đổi nhưng vẫn không đổi bên trong, tạo thành một đường đi giữa hai đường thẳng song song?',
        dapAn: {
          A: 'Đường xoắn ốc',
          B: 'Đường zigzag',
          C: 'Đường tròn',
          D: 'Đường sóng'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '4_8',
        noiDung: 'Hình tứ giác có 4 góc vuông và 4 cạnh bằng nhau được gọi là gì?',
        dapAn: {
          A: 'Hình chữ nhật',
          B: 'Hình thoi',
          C: 'Hình vuông',
          D: 'Hình bình hành'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '4_9',
        noiDung: 'Họa tiết nào sau đây là ví dụ của đối xứng tịnh tiến trong thiết kế vải?',
        dapAn: {
          A: 'Một bông hoa đơn lẻ được thêu ở giữa áo.',
          B: 'Họa tiết đường kẻ hoặc hình sóng chạy dọc theo chiều dài của vải.',
          C: 'Một logo hình tròn ở góc khăn.',
          D: 'Một họa tiết chỉ xuất hiện duy nhất một lần.'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '4_10',
        noiDung: 'Phép đối xứng nào được mô tả giống như việc soi một vật qua gương?',
        dapAn: {
          A: 'Đối xứng quay',
          B: 'Đối xứng tịnh tiến',
          C: 'Đối xứng gương (Đối xứng qua trục)',
          D: 'Đối xứng tâm'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '4_11',
        noiDung: 'Hình nào sau đây KHÔNG phải là ví dụ của đối xứng quay trong tự nhiên?',
        dapAn: {
          A: 'Quả khế khi được cắt ngang',
          B: 'Bông tuyết',
          C: 'Sao biển',
          D: 'Một chiếc lá cây bàng'
        },
        cauTraLoiDung: 'D'
      },
      {
        id: '4_12',
        noiDung: 'Hình thoi là một tứ giác có đặc điểm gì?',
        dapAn: {
          A: 'Có 4 góc vuông.',
          B: 'Có 4 cạnh bằng nhau.',
          C: 'Chỉ có 2 cạnh đối song song.',
          D: 'Có hai đường chéo bằng nhau.'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '4_13',
        noiDung: 'Khi gấp một tờ giấy có in họa tiết dọc theo một đường thẳng mà hai nửa của họa tiết trùng khớp hoàn toàn, đường gấp đó gọi là gì?',
        dapAn: {
          A: 'Tâm đối xứng',
          B: 'Trục đối xứng',
          C: 'Vectơ tịnh tiến',
          D: 'Góc quay'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '4_14',
        noiDung: 'Hình tròn được định nghĩa là tập hợp tất cả các điểm trên mặt phẳng cách một điểm cho trước (tâm) một khoảng cách không đổi gọi là gì?',
        dapAn: {
          A: 'Đường kính',
          B: 'Dây cung',
          C: 'Bán kính',
          D: 'Chu vi'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '4_15',
        noiDung: 'Trong kỹ thuật nhuộm sáp ong, sáp ong có vai trò gì về mặt nguyên lý?',
        dapAn: {
          A: 'Làm cho màu nhuộm đậm và đẹp hơn.',
          B: 'Tạo ra hiệu ứng loang màu tự nhiên.',
          C: 'Ngăn không cho thuốc nhuộm thấm vào vùng vải được phủ sáp (kháng nhuộm).',
          D: 'Giúp cho vải nhanh khô hơn sau khi nhuộm.'
        },
        cauTraLoiDung: 'C'
      }
    ]
  },
  // ĐỀ SỐ 5: KIẾN THỨC VĂN HÓA DÂN TỘC (NÂNG CAO 2)
  {
    id: 'de_so_5',
    tenDe: 'Tìm hiểu Văn hóa các dân tộc (Phần 2)',
    cauHoi: [
        {
            id: '5_1',
            noiDung: 'Cây chàm, nguyên liệu chính để nhuộm vải của nhiều dân tộc, có tên khoa học phổ biến là gì?',
            dapAn: {
              A: 'Indigofera tinctoria',
              B: 'Corchorus capsularis',
              C: 'Linum usitatissimum',
              D: 'Morus alba'
            },
            cauTraLoiDung: 'A'
        },
        {
            id: '5_2',
            noiDung: 'Trong văn hóa Chăm, họa tiết thường được tạo ra bằng kỹ thuật nào trong lúc dệt?',
            dapAn: {
              A: 'In trực tiếp lên vải',
              B: 'Vẽ bằng sáp ong',
              C: 'Dệt bổ sung sợi ngang (dùng que tre nâng hạ sợi dọc)',
              D: 'Thêu sau khi dệt xong'
            },
            cauTraLoiDung: 'C'
        },
        {
            id: '5_3',
            noiDung: 'Họa tiết "Cây đời" phổ biến trong hoa văn của nhiều dân tộc như Thái, Tày, Mường, có ý nghĩa gì?',
            dapAn: {
              A: 'Tượng trưng cho sự giàu có, sung túc.',
              B: 'Tượng trưng cho sự sinh sôi, phát triển, và kết nối các thế hệ.',
              C: 'Tượng trưng cho sức mạnh và quyền lực.',
              D: 'Tượng trưng cho chiến tranh và hòa bình.'
            },
            cauTraLoiDung: 'B'
        },
        {
            id: '5_4',
            noiDung: 'Đâu là một trong những thách thức mà nghề dệt thổ cẩm truyền thống của người Mạ đang đối mặt?',
            dapAn: {
              A: 'Thiếu các mẫu thiết kế mới.',
              B: 'Không có người muốn mua sản phẩm.',
              C: 'Sự cạnh tranh từ sản phẩm công nghiệp và nguyên liệu tự nhiên khan hiếm.',
              D: 'Chính phủ không cho phép phát triển.'
            },
            cauTraLoiDung: 'C'
        },
        {
            id: '5_5',
            noiDung: 'Phương thức truyền nghề dệt vải lanh của người H’Mông chủ yếu là gì?',
            dapAn: {
              A: 'Qua các trường lớp chính quy.',
              B: 'Qua sách vở và tài liệu cổ.',
              C: 'Qua các nghệ nhân nam giới trong làng.',
              D: 'Qua hình thức truyền miệng và thực hành trong gia đình (mẹ dạy con gái).'
            },
            cauTraLoiDung: 'D'
        },
        {
            id: '5_6',
            noiDung: 'Vải đay của người Khmer có đặc điểm nổi bật nào?',
            dapAn: {
              A: 'Mềm mịn như lụa, nhiều màu sắc sặc sỡ.',
              B: 'Độ bền cao, chống mài mòn, màu sắc tự nhiên mộc mạc.',
              C: 'Mỏng, nhẹ và trong suốt.',
              D: 'Không thấm nước và co giãn tốt.'
            },
            cauTraLoiDung: 'B'
        },
        {
            id: '5_7',
            noiDung: 'Trong trang phục người Tày, các phụ kiện trang trí chủ yếu được làm từ chất liệu gì?',
            dapAn: {
              A: 'Vàng và kim cương',
              B: 'Gỗ và tre',
              C: 'Bạc và đồng',
              D: 'Nhựa và thủy tinh'
            },
            cauTraLoiDung: 'C'
        },
        {
            id: '5_8',
            noiDung: 'Kỹ thuật thêu nào phổ biến và đặc sắc nhất của nhóm Dao Đỏ?',
            dapAn: {
              A: 'Thêu chữ thập (cross-stitch)',
              B: 'Thêu nổi',
              C: 'Thêu ruy băng',
              D: 'Thêu kim sa'
            },
            cauTraLoiDung: 'A'
        },
        {
            id: '5_9',
            noiDung: 'Theo bài viết, thuốc nhuộm chàm được coi là "vàng xanh" ở quốc gia nào thời cổ đại?',
            dapAn: {
              A: 'Việt Nam',
              B: 'Trung Quốc',
              C: 'Ai Cập',
              D: 'Ấn Độ'
            },
            cauTraLoiDung: 'D'
        },
        {
            id: '5_10',
            noiDung: 'Họa tiết nào thường xuất hiện trên trang phục của người có địa vị cao trong cộng đồng người Dao?',
            dapAn: {
              A: 'Hình xoắn ốc',
              B: 'Hình tam giác',
              C: 'Hình rồng, phượng hoàng',
              D: 'Hình hoa lá'
            },
            cauTraLoiDung: 'C'
        },
        {
            id: '5_11',
            noiDung: 'Người Nùng có ngôn ngữ và văn hóa giống với dân tộc nào?',
            dapAn: {
              A: 'Người Kinh và người Hoa.',
              B: 'Người Dao và người Mông.',
              C: 'Người Tày và một số nhánh người Tráng.',
              D: 'Người Khmer và người Chăm.'
            },
            cauTraLoiDung: 'C'
        },
        {
            id: '5_12',
            noiDung: 'Khuôn dệt của người Chăm có đặc điểm gì đặc biệt?',
            dapAn: {
              A: 'Là loại máy dệt công nghiệp hiện đại.',
              B: 'Rất lớn và cần nhiều người vận hành.',
              C: 'Một đầu buộc vào cột nhà, đầu kia buộc vào thắt lưng người dệt.',
              D: 'Được làm hoàn toàn bằng kim loại.'
            },
            cauTraLoiDung: 'C'
        },
        {
            id: '5_13',
            noiDung: 'Theo bài viết về kỹ thuật nhuộm sáp ong, sau khi nhuộm xong, sáp ong được loại bỏ bằng cách nào?',
            dapAn: {
              A: 'Cạo ra bằng dao.',
              B: 'Dùng hóa chất để hòa tan.',
              C: 'Để sáp tự bong ra khi phơi nắng.',
              D: 'Đun sôi vải trong nước hoặc dùng dung môi.'
            },
            cauTraLoiDung: 'D'
        },
        {
            id: '5_14',
            noiDung: 'Theo truyền thuyết, Bàn Vương được coi là thủy tổ của dân tộc nào?',
            dapAn: {
              A: 'Dân tộc Tày',
              B: 'Dân tộc Dao',
              C: 'Dân tộc Nùng',
              D: 'Dân tộc Mông'
            },
            cauTraLoiDung: 'B'
        },
        {
            id: '5_15',
            noiDung: 'Tiếng Tày có quan hệ gần gũi đến mức có thể giao tiếp trực tiếp với ngôn ngữ nào?',
            dapAn: {
              A: 'Tiếng Anh, tiếng Pháp',
              B: 'Tiếng Nhật, tiếng Hàn',
              C: 'Tiếng Nùng, tiếng Tráng, tiếng Lào, tiếng Thái',
              D: 'Tiếng Khmer, tiếng Chăm'
            },
            cauTraLoiDung: 'C'
        }
    ]
  },
  // ĐỀ SỐ 6: TOÁN HỌC VÀ HỌA TIẾT (NÂNG CAO 2)
  {
    id: 'de_so_6',
    tenDe: 'Toán học và Họa tiết (Phần 2)',
    cauHoi: [
        {
            id: '6_1',
            noiDung: 'Trong các họa tiết thổ cẩm, hình tứ giác có 4 cạnh bằng nhau nhưng các góc không nhất thiết phải vuông được gọi là gì?',
            dapAn: {
              A: 'Hình vuông',
              B: 'Hình chữ nhật',
              C: 'Hình thoi',
              D: 'Hình thang cân'
            },
            cauTraLoiDung: 'C'
        },
        {
            id: '6_2',
            noiDung: 'Một họa tiết hình hoa có 5 cánh đều nhau. Góc quay nhỏ nhất để họa tiết trông không đổi là bao nhiêu độ?',
            dapAn: {
              A: '60 độ',
              B: '72 độ (360/5)',
              C: '90 độ',
              D: '120 độ'
            },
            cauTraLoiDung: 'B'
        },
        {
            id: '6_3',
            noiDung: 'Loại đối xứng nào thể hiện sự lặp lại của một họa tiết qua một điểm trung tâm?',
            dapAn: {
              A: 'Đối xứng trục',
              B: 'Đối xứng tịnh tiến',
              C: 'Đối xứng quay',
              D: 'Tất cả các loại trên'
            },
            cauTraLoiDung: 'C'
        },
        {
            id: '6_4',
            noiDung: 'Họa tiết nào sau đây thường có cả đối xứng trục và đối xứng quay?',
            dapAn: {
              A: 'Một dải họa tiết hình sóng',
              B: 'Một họa tiết hình chiếc lá không cân đối',
              C: 'Một họa tiết hình ngôi sao 8 cánh đều',
              D: 'Một họa tiết hình chữ L'
            },
            cauTraLoiDung: 'C'
        },
        {
            id: '6_5',
            noiDung: 'Trong họa tiết thổ cẩm, các hình tam giác thường được sắp xếp để tạo thành hình lớn hơn như hình gì?',
            dapAn: {
              A: 'Hình tròn',
              B: 'Hình elip',
              C: 'Hình kim tự tháp hoặc hình sao',
              D: 'Hình Lưỡi liềm'
            },
            cauTraLoiDung: 'C'
        },
        {
            id: '6_6',
            noiDung: 'Hình chữ nhật là một tứ giác có đặc điểm gì?',
            dapAn: {
              A: 'Có 4 cạnh bằng nhau.',
              B: 'Có 4 góc vuông.',
              C: 'Có các đường chéo vuông góc.',
              D: 'Tất cả các đáp án trên.'
            },
            cauTraLoiDung: 'B'
        },
        {
            id: '6_7',
            noiDung: 'Họa tiết "Cây đời" thường thể hiện loại đối xứng nào rõ rệt nhất?',
            dapAn: {
              A: 'Đối xứng tịnh tiến',
              B: 'Đối xứng qua trục (đối xứng gương)',
              C: 'Đối xứng quay',
              D: 'Không có đối xứng'
            },
            cauTraLoiDung: 'B'
        },
        {
            id: '6_8',
            noiDung: 'Nếu một họa tiết có đối xứng quay bậc 3, góc quay nhỏ nhất của nó là bao nhiêu?',
            dapAn: {
              A: '90 độ',
              B: '60 độ',
              C: '180 độ',
              D: '120 độ (360/3)'
            },
            cauTraLoiDung: 'D'
        },
        {
            id: '6_9',
            noiDung: 'Hình dạng nào là biểu tượng của sự sinh sôi, phát triển không ngừng trong văn hóa người Mông?',
            dapAn: {
              A: 'Hình vuông',
              B: 'Đường thẳng',
              C: 'Đường xoắn ốc',
              D: 'Hình tam giác'
            },
            cauTraLoiDung: 'C'
        },
        {
            id: '6_10',
            noiDung: 'Trong các lựa chọn sau, hình nào có vô số trục đối xứng?',
            dapAn: {
              A: 'Hình vuông',
              B: 'Hình tam giác đều',
              C: 'Hình tròn',
              D: 'Hình lục giác đều'
            },
            cauTraLoiDung: 'C'
        },
        {
            id: '6_11',
            noiDung: 'Việc dệt các họa tiết lặp đi lặp lại trên một dải khăn là ứng dụng của phép biến hình nào trong toán học?',
            dapAn: {
              A: 'Phép quay',
              B: 'Phép vị tự',
              C: 'Phép tịnh tiến',
              D: 'Phép đối xứng tâm'
            },
            cauTraLoiDung: 'C'
        },
        {
            id: '6_12',
            noiDung: 'Một họa tiết hình mặt trời thường có loại đối xứng nào?',
            dapAn: {
              A: 'Chỉ có đối xứng trục',
              B: 'Chỉ có đối xứng tịnh tiến',
              C: 'Đối xứng quay',
              D: 'Không có đối xứng nào'
            },
            cauTraLoiDung: 'C'
        },
        {
            id: '6_13',
            noiDung: 'Trong không gian 2 chiều, đối xứng gương còn được gọi là gì?',
            dapAn: {
              A: 'Đối xứng tâm',
              B: 'Đối xứng qua trục',
              C: 'Đối xứng tịnh tiến',
              D: 'Đối xứng quay'
            },
            cauTraLoiDung: 'B'
        },
        {
            id: '6_14',
            noiDung: 'Tổng các góc trong của một đa giác hình tam giác là bao nhiêu?',
            dapAn: {
              A: '90 độ',
              B: '180 độ',
              C: '360 độ',
              D: 'Tùy thuộc vào loại tam giác'
            },
            cauTraLoiDung: 'B'
        },
        {
            id: '6_15',
            noiDung: 'Họa tiết hai con chim đậu đối xứng nhau trên cành cây là ví dụ của loại đối xứng nào?',
            dapAn: {
              A: 'Đối xứng tịnh tiến',
              B: 'Đối xứng quay',
              C: 'Đối xứng qua trục',
              D: 'Không có đối xứng'
            },
            cauTraLoiDung: 'C'
        }
    ]
  },
   // ĐỀ SỐ 7: KIẾN THỨC VỀ CÁC DÂN TỘC
   {
    id: 'de_so_7',
    tenDe: 'Kiểm tra kiến thức Văn hóa các dân tộc Việt Nam',
    cauHoi: [
      {
        id: '7_1',
        noiDung: 'Theo bài viết, dân tộc Dao còn được gọi bằng tên nào khác?',
        dapAn: {
          A: 'Người Kinh',
          B: 'Người Dìu Miền hoặc Yao',
          C: 'Người Mông',
          D: 'Người Tày'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '7_2',
        noiDung: 'Nguyên liệu chính để người H’Mông dệt vải truyền thống là gì?',
        dapAn: {
          A: 'Sợi tơ tằm',
          B: 'Sợi bông',
          C: 'Sợi lanh',
          D: 'Sợi đay'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '7_3',
        noiDung: 'Dân tộc Khmer ở Việt Nam sinh sống chủ yếu ở khu vực nào?',
        dapAn: {
          A: 'Miền núi phía Bắc',
          B: 'Đồng bằng sông Hồng',
          C: 'Duyên hải Nam Trung Bộ',
          D: 'Đồng bằng sông Cửu Long'
        },
        cauTraLoiDung: 'D'
      },
      {
        id: '7_4',
        noiDung: 'Màu sắc chủ đạo trên vải thổ cẩm của người Mạ thường là gì?',
        dapAn: {
          A: 'Xanh dương và trắng',
          B: 'Tím và hồng',
          C: 'Đỏ, đen, vàng, và trắng',
          D: 'Chỉ có màu đen'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '7_5',
        noiDung: 'Kỹ thuật nhuộm "kháng nhuộm" sử dụng sáp ong để tạo họa tiết có tên gọi phổ biến là gì?',
        dapAn: {
          A: 'Nhuộm chàm',
          B: 'Nhuộm sáp ong (Batik)',
          C: 'Nhuộm buộc (Tie-dye)',
          D: 'Nhuộm in hoa'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '7_6',
        noiDung: 'Theo truyền thuyết của người Dao, ai là người đã sáng tạo ra nghề nhuộm vải chàm?',
        dapAn: {
          A: 'Các vị thần linh trên núi',
          B: 'Các chiến binh sau trận chiến',
          C: 'Các bà, các mẹ trong cộng đồng',
          D: 'Các vị vua và hoàng hậu'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '7_7',
        noiDung: 'Đâu là món ăn truyền thống không thể thiếu và thường được nấu thành súp của người H’Mông?',
        dapAn: {
          A: 'Phở bò',
          B: 'Bún chả',
          C: 'Dưa muối',
          D: 'Cơm lam'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '7_8',
        noiDung: 'Lễ hội Chôl Chnăm Thmây là Tết cổ truyền của dân tộc nào?',
        dapAn: {
          A: 'Dân tộc Tày',
          B: 'Dân tộc Dao',
          C: 'Dân tộc Khmer',
          D: 'Dân tộc Mạ'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '7_9',
        noiDung: 'Dân tộc Lô Lô ở Việt Nam được chia thành những nhóm chính nào?',
        dapAn: {
          A: 'Lô Lô Đỏ và Lô Lô Xanh',
          B: 'Lô Lô Đen, Lô Lô Hoa và Lô Lô Trắng',
          C: 'Lô Lô Núi và Lô Lô Sông',
          D: 'Lô Lô Tiền và Lô Lô Chàm'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '7_10',
        noiDung: 'Dân tộc nào có dân số đông thứ hai tại Việt Nam, chỉ sau người Kinh?',
        dapAn: {
          A: 'Người Nùng',
          B: 'Người Mông',
          C: 'Người Tày',
          D: 'Người Dao'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '7_11',
        noiDung: 'Theo tín ngưỡng người Dao, màu chàm trên trang phục có ý nghĩa tâm linh gì?',
        dapAn: {
          A: 'Tượng trưng cho sự giàu có và quyền lực.',
          B: 'Giúp xua đuổi tà ma và mang lại may mắn.',
          C: 'Thể hiện sự tang tóc và đau buồn.',
          D: 'Chỉ là màu sắc trang trí cho đẹp mắt.'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '7_12',
        noiDung: 'Trang phục của phụ nữ nhóm Dao nào đặc trưng với việc đính các đồng xu bạc?',
        dapAn: {
          A: 'Dao Đỏ',
          B: 'Dao Quần Chẹt',
          C: 'Dao Thanh Y',
          D: 'Dao Tiền'
        },
        cauTraLoiDung: 'D'
      },
      {
        id: '7_13',
        noiDung: 'Làng nghề dệt thổ cẩm nổi tiếng nhất của người Chăm ở Ninh Thuận là làng nào?',
        dapAn: {
          A: 'Làng Vạn Phúc',
          B: 'Làng Mỹ Nghiệp và Chung Mỹ',
          C: 'Làng Luống Nọi',
          D: 'Làng Pác Rằng'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '7_14',
        noiDung: 'Người Nùng sống tập trung chủ yếu ở khu vực nào của Việt Nam?',
        dapAn: {
          A: 'Đồng bằng sông Cửu Long',
          B: 'Tây Nguyên',
          C: 'Duyên hải Nam Trung Bộ',
          D: 'Các tỉnh đông bắc Bắc Bộ'
        },
        cauTraLoiDung: 'D'
      },
      {
        id: '7_15',
        noiDung: 'Nghề dệt vải của người Mạ được truyền lại chủ yếu qua ai?',
        dapAn: {
          A: 'Cha truyền cho con trai.',
          B: 'Thầy giáo dạy cho học trò trong trường làng.',
          C: 'Mẹ truyền cho con gái.',
          D: 'Nghệ nhân trong làng dạy chung cho cả nam và nữ.'
        },
        cauTraLoiDung: 'C'
      }
    ]
  },
  // ĐỀ SỐ 8: HÌNH HỌC VÀ ĐỐI XỨNG TRONG HỌA TIẾT
  {
    id: 'de_so_8',
    tenDe: 'Khám phá Toán học trong Họa tiết truyền thống',
    cauHoi: [
      {
        id: '8_1',
        noiDung: 'Trong họa tiết vải, khi một hình được lặp đi lặp lại theo một hướng cố định mà không thay đổi hình dạng, đó là loại đối xứng nào?',
        dapAn: {
          A: 'Đối xứng gương',
          B: 'Đối xứng quay',
          C: 'Đối xứng tịnh tiến',
          D: 'Đối xứng tâm'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '8_2',
        noiDung: 'Một hình vuông có tất cả bao nhiêu trục đối xứng?',
        dapAn: {
          A: '1 trục',
          B: '2 trục',
          C: '4 trục',
          D: 'Vô số trục'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '8_3',
        noiDung: 'Một họa tiết hình ngôi sao 6 cánh đều nhau sẽ có đối xứng quay bậc mấy?',
        dapAn: {
          A: 'Bậc 3 (khi xoay 120 độ)',
          B: 'Bậc 4 (khi xoay 90 độ)',
          C: 'Bậc 6 (khi xoay 60 độ)',
          D: 'Bậc 8 (khi xoay 45 độ)'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '8_4',
        noiDung: 'Trong họa tiết thổ cẩm của người Mạ, hình dạng nào thường được dùng để mô tả các đỉnh núi?',
        dapAn: {
          A: 'Hình tròn',
          B: 'Hình vuông',
          C: 'Hình tam giác',
          D: 'Hình lục giác'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '8_5',
        noiDung: 'Trong toán học, đường thẳng chia một hình thành hai phần là ảnh phản chiếu của nhau được gọi là gì?',
        dapAn: {
          A: 'Trục tung',
          B: 'Trục hoành',
          C: 'Trục đối xứng',
          D: 'Đường phân giác'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '8_6',
        noiDung: 'Hình ảnh nào trong tự nhiên là ví dụ điển hình của đối xứng gương (đối xứng trục)?',
        dapAn: {
          A: 'Vỏ ốc sên',
          B: 'Thân cây',
          C: 'Cánh bướm',
          D: 'Mạng nhện'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '8_7',
        noiDung: 'Họa tiết hình quả trám trong thổ cẩm còn có tên gọi hình học là gì?',
        dapAn: {
          A: 'Hình bình hành',
          B: 'Hình thoi',
          C: 'Hình thang',
          D: 'Hình chữ nhật'
        },
        cauTraLoiDung: 'B'
      },
      {
        id: '8_8',
        noiDung: 'Hình dạng nào thường tượng trưng cho sự trọn vẹn, thống nhất và là tâm điểm của các hoa văn?',
        dapAn: {
          A: 'Hình tròn',
          B: 'Hình vuông',
          C: 'Hình tam giác',
          D: 'Hình ngôi sao'
        },
        cauTraLoiDung: 'A'
      },
      {
        id: '8_9',
        noiDung: 'Khi một họa tiết có thể xoay quanh tâm một góc 90 độ và giữ nguyên hình dạng, nó có đối xứng quay bậc mấy?',
        dapAn: {
          A: 'Bậc 2',
          B: 'Bậc 3',
          C: 'Bậc 4',
          D: 'Bậc 8'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '8_10',
        noiDung: 'Họa tiết hình con sên hoặc đường cong liên tục tạo thành các vòng tròn quanh một điểm trung tâm được gọi là gì?',
        dapAn: {
          A: 'Đường elip',
          B: 'Đường zigzag',
          C: 'Đường xoắn ốc',
          D: 'Đường parabol'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '8_11',
        noiDung: '"Đối xứng gương" còn có tên gọi khác trong toán học là gì?',
        dapAn: {
          A: 'Đối xứng tịnh tiến',
          B: 'Đối xứng quay',
          C: 'Đối xứng phản xạ (Đối xứng trục)',
          D: 'Đối xứng tâm'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '8_12',
        noiDung: 'Trong các họa tiết lặp lại, hình dạng nào có thể ghép lại với nhau để tạo thành mạng lưới hình tổ ong?',
        dapAn: {
          A: 'Hình tam giác',
          B: 'Hình vuông',
          C: 'Hình ngũ giác',
          D: 'Hình lục giác'
        },
        cauTraLoiDung: 'D'
      },
      {
        id: '8_13',
        noiDung: 'Việc sắp xếp các hàng gạch hoặc các hàng cột trong kiến trúc là ví dụ cho loại đối xứng nào?',
        dapAn: {
          A: 'Đối xứng gương',
          B: 'Đối xứng quay',
          C: 'Đối xứng tịnh tiến',
          D: 'Không có đối xứng'
        },
        cauTraLoiDung: 'C'
      },
      {
        id: '8_14',
        noiDung: 'Họa tiết hai con rồng chầu vào một viên ngọc thường được sắp xếp theo loại đối xứng nào?',
        dapAn: {
          A: 'Đối xứng qua trục',
          B: 'Đối xứng tịnh tiến',
          C: 'Đối xứng quay',
          D: 'Không đối xứng'
        },
        cauTraLoiDung: 'A'
      },
      {
        id: '8_15',
        noiDung: 'Tổng các góc trong của một đa giác có 6 cạnh (hình lục giác) là bao nhiêu độ?',
        dapAn: {
          A: '360°',
          B: '540°',
          C: '720°',
          D: '1080°'
        },
        cauTraLoiDung: 'C'
      }
    ]
  }

];

export default deThiTracNghiem;
